import { css, etiColors, mediaQueries } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const seatWrapperStyles = isOpen => css`
  display: flex;
  flex-direction: row;

  ${isOpen ? css`
        align-items: flex-start;
        border-bottom: 0.125rem solid ${etiColors.grayScale[4]};
        flex: 1 0 auto;
        margin: 0 0.8125rem;
        padding: 0.8125rem 0;

        &:last-child {
          border-bottom: none;
        }
      ` : css`
        align-items: center;
        flex: 1 auto;
        margin: 0.8125rem;
        padding: 0;
        white-space: nowrap;

        &:last-child {
          margin-right: 0;
          padding-right: 2.8125rem;
          [dir='rtl'] & {
            margin-left: 0;
            padding-left: 2.8125rem;
            padding-right: 0;
          }
        }
      `};

  @media ${mediaQueries.medium.up} {
    border-bottom: 0;

    ${isOpen ? css`
          margin: 0;
          max-width: 50%;
          padding-bottom: 1.875rem;

          &:nth-child(even) {
            padding-left: 1.969rem;
            [dir='rtl'] & {
              padding-left: 0;
              padding-right: 2.8125rem;
            }
          }

          /* stylelint-disable no-descending-specificity */
          &:nth-child(odd) {
            border-right: ${isOpen && '0.063rem'} solid ${etiColors.grayScale[4]};
            padding-right: 1.969rem;
            [dir='rtl'] & {
              border-left: ${isOpen && '0.063rem'} solid ${etiColors.grayScale[4]};
              border-right: 0;
              padding-left: 1.969rem;
              padding-right: 0;
            }
          }
          /* stylelint-enable no-descending-specificity */
        ` : css`
          flex-basis: 120px;
          padding-right: 0;
        `};
  }
`;
export const SeatWrapper = _ref => {
  let {
    isOpen,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: seatWrapperStyles(isOpen),
    ...rest
  });
};
const textContentStyles = isOpen => css`
  display: flex;
  flex-direction: column;

  h3 {
    color: ${etiColors.black};
    font-size: ${isOpen ? '0.75rem' : '0.563rem'};
    font-weight: 600;
    font-weight: 700;
    margin-bottom: ${isOpen ? '0.25rem' : 0};
    white-space: ${isOpen ? 'wrap' : 'nowrap'};
  }

  span {
    color: ${etiColors.grayScale[10]};
    display: ${isOpen ? 'block' : 'none'};
    font-size: ${isOpen ? '0.75rem' : '0.563rem'};
    line-height: 1.2;
    margin-bottom: ${isOpen ? '0.188rem' : 0};
    white-space: ${isOpen ? 'wrap' : 'nowrap'};
  }

  p {
    color: ${etiColors.grayScale[10]};
    font-size: ${isOpen ? '0.75rem' : '0.563rem'};
  }

  @media ${mediaQueries.medium.up} {
    h3 {
      font-size: ${isOpen ? '1rem' : '0.75rem'};
      font-weight: 700;
      line-height: 1;
      margin-bottom: ${isOpen ? '0.25rem' : 0};
    }
    span {
      display: block;
      font-size: ${isOpen ? '0.75rem' : '0.563rem'};
      line-height: 1.2;
      margin-bottom: ${isOpen ? '0.188rem' : 0};
    }
    p {
      font-size: ${isOpen ? '0.75rem' : '0.563rem'};
    }
  }
`;
export const TextContent = _ref2 => {
  let {
    isOpen,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: textContentStyles(isOpen),
    ...rest
  });
};
const iconWrapperStyles = (isOpen, size) => css`
  margin-left: 0;
  margin-right: ${isOpen ? '0.75rem' : '0.563rem'};
  min-width: ${`${size}rem`};
  width: ${`${size}rem`};

  [dir='rtl'] & {
    margin-left: ${isOpen ? '0.75rem' : '0.563rem'};
    margin-right: 0;
  }

  svg {
    display: block;
  }
`;
export const IconWrapper = _ref3 => {
  let {
    isOpen,
    size,
    ...rest
  } = _ref3;
  return /*#__PURE__*/_jsx("div", {
    className: iconWrapperStyles(isOpen, size),
    ...rest
  });
};
export const iconClassName = isOpen => css`
  transform: ${isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
`;
const legendBarStyles = isOpen => css`
  background-color: ${etiColors.white};
  display: block;
  flex: 1 0 ${isOpen ? `70%` : null};
  max-height: ${isOpen ? `600px` : `48px`};
  overflow: ${isOpen ? `hidden` : null};

  /* padding: 0.6875rem 1.125rem ${isOpen && 0}; */
  width: 100%;
  z-index: 5;
`;
export const LegendBar = _ref4 => {
  let {
    isOpen,
    ...rest
  } = _ref4;
  return /*#__PURE__*/_jsx("div", {
    className: legendBarStyles(isOpen),
    ...rest
  });
};
const toggleWrapperStyles = css`
  background: #fff;
  background: linear-gradient(
    to right,
    rgb(255 255 255 / 0%) 0%,
    rgb(255 255 255 / 100%) 50%,
    rgb(255 255 255 / 100%) 100%
  );
  cursor: pointer;
  padding: 0.75rem 0.625rem 0.75rem 1.875rem;
  position: absolute;
  right: 0;

  [dir='rtl'] & {
    background: linear-gradient(
      to left,
      rgb(255 255 255 / 0%) 0%,
      rgb(255 255 255 / 100%) 50%,
      rgb(255 255 255 / 100%) 100%
    );
    left: 0;
    padding: 0.75rem 1.875rem 0.75rem 0.625rem;
    right: unset;
  }
`;
export const ToggleWrapper = props => /*#__PURE__*/_jsx("span", {
  className: toggleWrapperStyles,
  ...props
});
const legendWrapperStyles = css`
  display: flex;
  height: 100%;
  margin: 0 auto;
  max-width: 848px;
  position: relative;
  width: 100%;
`;
export const LegendWrapper = _ref5 => {
  let {
    innerRef,
    ...rest
  } = _ref5;
  return /*#__PURE__*/_jsx("div", {
    className: legendWrapperStyles,
    ref: innerRef,
    ...rest
  });
};
const childWrapperStyles = isOpen => css`
  align-content: start;
  display: flex;
  flex: 1;
  flex-direction: ${isOpen ? `column` : `row`};
  margin-top: ${isOpen && `45px`};
  overflow: auto;
  padding-left: 0;
  padding-right: 1.25rem;

  [dir='rtl'] & {
    padding-left: 1.25rem;
    padding-right: 0;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${mediaQueries.medium.up} {
    flex-flow: ${isOpen && `row`} ${isOpen && `wrap`};
    padding: ${isOpen ? `2.5rem 2.5rem 0 2.5rem` : `0 2.5rem 0 0`};
    width: 100%;
    [dir='rtl'] & {
      padding: ${isOpen ? `2.5rem 0 2.5rem 2.5rem` : `0 0 0 2.5rem`};
    }
  }
`;
export const ChildWrapper = _ref6 => {
  let {
    isOpen,
    ...rest
  } = _ref6;
  return /*#__PURE__*/_jsx("div", {
    className: childWrapperStyles(isOpen),
    ...rest
  });
};
//# sourceMappingURL=StyledComponents.js.map